export default __webpack_public_path__ + "static/media/WORCESTERSHIRE_2017_COVER.af241eeb.jpg";